import { useCallback, useEffect, useState } from 'react';
import { featureFlagsAPI } from '../services/api';
import { UNIX_IDENTITY_FLAG } from '../domain/identity/studentIdIntake';

/**
 * Whether Add User should use generate / existing / lead Student ID intake.
 */
export function useUnixIdentityEnabled() {
  const [enabled, setEnabled] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await featureFlagsAPI.status([UNIX_IDENTITY_FLAG]);
      setEnabled(Boolean(res.data?.data?.enabled?.[UNIX_IDENTITY_FLAG]));
    } catch {
      setEnabled(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, [refresh]);

  return enabled;
}
